// extracted by mini-css-extract-plugin
export default {"container":"jL-z","timeTop":"kL-z","timeCountdown":"lL-z","cta":"mL-z","disabled":"nL-z","product":"oL-z"};